import gql from 'graphql-tag';

export const CREATE_TEMPLATE = gql`
  mutation CreateTemplate($input: CreateBusinessProcessFlowTemplateInput!) {
    bpf {
      createTemplate(input: $input) {
        businessProcessFlowId
      }
    }
  }
`;
